<div class="container-body">
  <app-main-header *ngIf="authService.isAuthenticated()"></app-main-header>
  <div class="container-app" [ngClass]="[!authService.isAuthenticated() ? 'container-login' : '']">
    <ngx-loading
      [show]="true"
      [hidden]="!loading"
      [config]="{ backdropBorderRadius: '14px', fullScreenBackdrop: true }"
    ></ngx-loading>
    <router-outlet (activate)="onRouterActivate()"></router-outlet>
  </div>
</div>
<app-edp-footer></app-edp-footer>
